import React from 'react';
import PropTypes from 'prop-types';

const TopbarIconButton = ({
  className = '',
  title,
  ariaLabel,
  ariaPressed,
  disabled = false,
  onClick,
  onMouseDown,
  onTouchStart,
  type = 'button',
  children,
}) => (
  <button
    type={type}
    className={`respark_topbar-btn${className ? ` ${className}` : ''}`}
    title={title}
    aria-label={ariaLabel || title}
    aria-pressed={ariaPressed}
    disabled={disabled}
    onClick={onClick}
    onMouseDown={onMouseDown}
    onTouchStart={onTouchStart}
  >
    {children}
  </button>
);

TopbarIconButton.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaPressed: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onTouchStart: PropTypes.func,
  type: PropTypes.string,
  children: PropTypes.node,
};

export default TopbarIconButton;
